// Our Favorites Carousel — standalone, self-contained.
// Not derived from any Wonder core JS file. Supports multiple instances
// on the same page (each carousel finds only its own track/nav/slides).

document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-cofp-carousel]').forEach(function (carousel) {
    var track = carousel.querySelector('[data-cofp-track]');
    var slides = track ? Array.prototype.slice.call(track.children) : [];
    var prevBtn = carousel.querySelector('[data-cofp-prev]');
    var nextBtn = carousel.querySelector('[data-cofp-next]');
    if (!track || slides.length === 0) return;

    var index = 0;
    var autoplayDelay = 5000;
    var timer = null;
    var stepVw = 31;

    var render = function () {
      var length = slides.length;
      var half = Math.floor(length / 2);

      slides.forEach(function (slide, i) {
        var raw = i - index;
        var offset = ((raw + half + length) % length) - half;

        var absOffset = Math.abs(offset);
        var scale = absOffset === 0 ? 1 : absOffset === 1 ? 0.72 : 0.6;
        var opacity = absOffset === 0 ? 1 : absOffset === 1 ? 0.9 : 0;

        slide.style.transform =
          'translateX(calc(-50% + ' + offset * stepVw + 'vw)) scale(' + scale + ')';
        slide.style.opacity = opacity;
        slide.style.zIndex = String(10 - absOffset);
        slide.classList.toggle('cofp__slide--active', offset === 0);
      });
    };

    var goTo = function (newIndex) {
      index = (newIndex + slides.length) % slides.length;
      render();
    };

    var next = function () {
      goTo(index + 1);
    };
    var prev = function () {
      goTo(index - 1);
    };

    var startAutoplay = function () {
      stopAutoplay();
      if (slides.length > 1) {
        timer = setInterval(next, autoplayDelay);
      }
    };
    var stopAutoplay = function () {
      if (timer) clearInterval(timer);
    };

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        next();
        startAutoplay();
      });
    }
    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        prev();
        startAutoplay();
      });
    }

    carousel.addEventListener('mouseenter', stopAutoplay);
    carousel.addEventListener('mouseleave', startAutoplay);

    goTo(0);
    startAutoplay();
  });
});